/* This component is used for the search in the header */
import Srcset from "@/components/common/Srcset";
import SearchIcon from "@/components/Logos/Search";

export default function Search({ isSuperbrandHeroPresent, className, isPWA }) {
  return isPWA ? (
    <Srcset
      requirePath={true}
      svgFile={true}
      src={"images/Icons/Search.svg"}
      alt="Search"
      height={"20"}
      width={"20"}
      className={className}
      dataga4={"App: Search"}
    />
  ) : (
    <SearchIcon
      className={className}
      height="20"
      width="20"
      stroke={isSuperbrandHeroPresent ? "#ffffff" : "#2f2f30"}
      fill="none"
    />
  );
}
